import { useErrorBoundaryContext } from "../../components/ErrorBoundaryContextProvider";
import { useErrorReportingContext } from "./ErrorReportingContextProvider";
import reportError from "./reportError";
/**
 * Creates a report exception function that adds some extra reporting tags (like
 * pageSector)
 */
export const useReportError = () => {
    const errorBoundaryContext = useErrorBoundaryContext();
    const errorReportingContext = useErrorReportingContext();
    return (error) => {
        if (!errorBoundaryContext.reportingEnabled) {
            return;
        }
        reportError(error, errorReportingContext);
    };
};
export default useReportError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVwb3J0RXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZXJyb3JzL2Vycm9yUmVwb3J0aW5nL3VzZVJlcG9ydEVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSx1QkFBdUIsRUFBRSxNQUFNLCtDQUErQyxDQUFDO0FBQ3hGLE9BQU8sRUFBRSx3QkFBd0IsRUFBRSxNQUFNLGlDQUFpQyxDQUFDO0FBQzNFLE9BQU8sV0FBVyxNQUFNLGVBQWUsQ0FBQztBQUl4Qzs7O0dBR0c7QUFDSCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsR0FBa0IsRUFBRTtJQUNoRCxNQUFNLG9CQUFvQixHQUFHLHVCQUF1QixFQUFFLENBQUM7SUFDdkQsTUFBTSxxQkFBcUIsR0FBRyx3QkFBd0IsRUFBRSxDQUFDO0lBRXpELE9BQU8sQ0FBQyxLQUFLLEVBQUUsRUFBRTtRQUNmLElBQUksQ0FBQyxvQkFBb0IsQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDO1lBQzNDLE9BQU87UUFDVCxDQUFDO1FBQ0QsV0FBVyxDQUFDLEtBQUssRUFBRSxxQkFBcUIsQ0FBQyxDQUFDO0lBQzVDLENBQUMsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=